export function raise(error: any): never {
  throw error;
}
